import { render, staticRenderFns } from "./input-number-widget.vue?vue&type=template&id=cbf3768c&scoped=true"
import script from "./input-number-widget.vue?vue&type=script&lang=js"
export * from "./input-number-widget.vue?vue&type=script&lang=js"
import style0 from "./input-number-widget.vue?vue&type=style&index=0&id=cbf3768c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf3768c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbf3768c')) {
      api.createRecord('cbf3768c', component.options)
    } else {
      api.reload('cbf3768c', component.options)
    }
    module.hot.accept("./input-number-widget.vue?vue&type=template&id=cbf3768c&scoped=true", function () {
      api.rerender('cbf3768c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/input-number-widget.vue"
export default component.exports